import { NgIfContext } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { SpecialistsService } from 'src/app/services/v2/users/specialists.service';

@Component({
  selector: 'app-plan-follow-up-sessions',
  templateUrl: './plan-follow-up-sessions.component.html',
  styleUrl: './plan-follow-up-sessions.component.scss'
})
export class PlanFollowUpSessionsComponent implements OnInit {
  private currentUser = JSON.parse(localStorage.getItem('user'));
  public loadingState: boolean = true;
  public coach:any;
  public followUpPlans: any = {
    plans: []
  };
  noPlans: TemplateRef<NgIfContext<boolean>>;
  loading: TemplateRef<NgIfContext<boolean>>;
  protected locale: string = this._language.getLanguage();
  constructor(private specialistsService: SpecialistsService,
    private router: ActivatedRoute,
    private _language: LanguageService
  ) {

  }
  ngOnInit() {
    const assignedCoach = this.currentUser?.coach;

    this.router.queryParams.subscribe(params => {
      const userIdFromParams = params['userId'];

      if (userIdFromParams) {
        this.coach = { id: userIdFromParams };
      } else if (assignedCoach) {
        this.coach = assignedCoach;
      }

      if (this.coach) {
        this.getPlansCoach();
      }
    });
      
  }

  getPlansCoach() {
    this.loadingState = true;
    this.specialistsService.getPlansCoach(this.coach?.id).subscribe({
      next: (res) => {
        this.followUpPlans = res.data;
        this.coach = res.data;

      },
      complete: () => {
        this.loadingState = false;
      },
      error: () => {
        this.loadingState = false;
      }
    })
  }

  formatCurrency(amount, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  buyPlan(planPath) {
    this.loadingState = true;
    this.specialistsService.buyPlan(planPath).subscribe({
      next: (res) => {
        window.location.href = res.redirect_to;
      },
      complete: () => {
        this.loadingState = false;
      },
      error: () => {
        this.loadingState = false;
        alert("Error")
      }
    })
  }
}
